import {
    StyleSheet, Text,
    View, ActivityIndicator,
    Pressable,
    TouchableOpacity
} from 'react-native';
import React, { useEffect } from 'react';
import { useFonts } from 'expo-font';
import { Poppins_700Bold } from '@expo-google-fonts/poppins';
import {
    LabledTextField,
    ActionButton,
    HaveAccount
} from '../SharedWidgets/LoginAndSignup';
import { navStack } from '../../Types/uitypes';
import RememberAndForgot from './widgets/RememberAndForgot';
import { useNavigation } from '@react-navigation/native';
import { useLoginStore } from './LoginStore';


export default function LoginScreen() {

    const navigation = useNavigation<navStack>();

    const {
        eyeState,
        toggleEyeState,
        email,
        password,
        setEmail,
        setPassword,
        onLoginWithCallback,
        hideActivityIndicator,
        toggleActivityIndicator,
        sendOtp
    } = useLoginStore();


    const [fontsLoaded] = useFonts({ Poppins_700Bold });
    if (!fontsLoaded) return null;

    async function handleLogin() {
        toggleActivityIndicator();
        onLoginWithCallback((user) => {
            navigation.navigate("CoupansScreen", { user })
        });
    }

    async function handleFogotPasword() {
        if (email == "") {
            window.alert("Enter email to send otp")
        } else {
            const confirmed = window.confirm(
                `Send Otp on ${email}`
            );
            if (confirmed) {
                toggleActivityIndicator();
                sendOtp(() => {
                    navigation.navigate("ForgotPasswordScreen", { email: email })
                })

            }
        }
    }



    return (
        <View style={styles.root}>

            <TouchableOpacity
                onPress={() => navigation.navigate("HelpScreen")}
                style={{
                    position: "absolute",
                    top: 12,
                    right: 16,
                    zIndex: 10,
                    padding: 8
                }}
            >
                <Text style={{ color: "#007AFF", fontWeight: "600" }}>
                    Help
                </Text>
            </TouchableOpacity>

            <Text
                style={{ fontFamily: 'Poppins_700Bold', fontSize: 24, textAlign: "center" }}
            >
                Hi, Welcome Back! 👋
            </Text>

            <LabledTextField
                hint='example@gmail.com'
                title='Email'
                value={email}
                onValueChange={setEmail}
            />

            <LabledTextField
                hint="Enter Your Password"
                title="Password"
                useEye={true}
                value={password}
                onValueChange={setPassword}
                eyeState={eyeState}
                toggleEye={toggleEyeState}
            />

            <RememberAndForgot onForgotPassword={handleFogotPasword} />

            <ActionButton label='LOGIN' onClick={handleLogin} />

            <HaveAccount
                messageText='Don’t have an account'
                actionText='Sign Up'
                actionTextPress={() => navigation.navigate("SignUpScreeen")}

            />
            {hideActivityIndicator && <View style={styles.container}>
                <ActivityIndicator size="large" color="#007AFF" />
            </View>}

        </View>
    );
}

const styles = StyleSheet.create({
    root: {
        backgroundColor: "white",
        flex: 1,
        gap: 12,
        paddingHorizontal: 12,
        paddingVertical: 12,
    },
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    },
});